import type { ReactNode } from "react";

interface Props {
  label: string;
  required?: boolean;
  error?: string;
  hint?: ReactNode;
  htmlFor?: string;
  children: ReactNode;
}

export default function Field({ label, required, error, hint, htmlFor, children }: Props) {
  return (
    <div className={`field${error ? " invalid" : ""}`}>
      <label htmlFor={htmlFor}>
        {label}
        {required && <span className="req">*</span>}
      </label>
      {children}
      {hint && <div className="hint">{hint}</div>}
      {error && <div className="err">{error}</div>}
    </div>
  );
}
